import { Box, Grid } from "@mui/material";
import { CAR_STATUS } from "../../../utils/constants/carData";
import { useSelector } from "react-redux";
import { reducerPaths } from "../../../app/reducerPaths";

export const cars = [
  {
    id: 1,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 2,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 3,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 4,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 5,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 6,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 7,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 8,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 9,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
  {
    id: 10,
    image:
      "https://stimg.cardekho.com/images/carexteriorimages/630x420/BMW/M5-2025/11821/1719462197562/front-left-side-47.jpg?impolicy=resize&imwidth=480",
    year: "2020",
    make: "BMW",
    model: "X3 | 301",
    vin: "5UXTY5C00LTI38420",
    odometer: "56,000 KM",
  },
];

const CarsList = ({
  showRemainingTime = false,
  showMenuButton,
  showSimilarCarsButton,
  isGarageCar = false,
  isUpcomingCar = false,
  isRecentlyAddedCar = false,
  isUnSoldCar = false,
  isSoldCar = false,
  cars = [],
  Component,
  ChildComponent,
  showEdit,
  onEdit,
  onEditCb,
  showRelist,
  onRelist,
  onClick,
  timerRemainingSecondsHandler,
  showCancelAuction,
  onCancelAuction,
  onClickShowSimilarCars,
  onProcessPayment,
  showCurrentHighestOffer,
  showCarLabelStatus,
  cardWidth,
  cardMinWidth,
  showAgentPendingApprovalStatus,
  tab,
  cardType,
  ...otherProps
}) => {

  console.log(cardType, `CarsList`)

  const auth = useSelector(store => store[reducerPaths.auth]);

  const getStatus = (car) => {
    if (isGarageCar) {
      // TODO: Add case for recently added for draft and list to auction
      if (isRecentlyAddedCar) return CAR_STATUS.DRAFT;
      else if (isUnSoldCar) return CAR_STATUS.UNSOLD_CAR;
      else if (isSoldCar) return CAR_STATUS.SOLD_CAR;
    } else if (isUpcomingCar) {
      if (car.Admin_Approval_Status === 0) return CAR_STATUS.APPROVAL_PENDING;
      else if (car.Buy_now_DateTime) return CAR_STATUS.BUY_NOW;
    }
    return null;
  };

  const getRemainingSeconds = (car) => {
    if (timerRemainingSecondsHandler) {
      return timerRemainingSecondsHandler(car, car?.liveAuctionOrBuyNowTab, auth);
    } else {
      return 0;
    }
  };

  return (
    <Box sx={{ 
      scrollbarWidth: "none !important", /* Firefox */
      "-ms-overflow-style": "none"  /* IE and Edge */
    }}>
      <Grid container spacing={2}
        sx={{ 
          scrollbarWidth: "none !important", /* Firefox */
          "-ms-overflow-style": "none"  /* IE and Edge */
        }}
      >
        {cars.map((car) => (
          <Component
            car={car}
            showRemainingTime={showRemainingTime}
            isGarageCar={isGarageCar}
            Component={ChildComponent}
            showEdit={showEdit}
            onEdit={onEdit}
            onEditCb={onEditCb}
            showRelist={showRelist}
            onRelist={onRelist}
            onClick={onClick ? () => {
              if (onClick) onClick(car);
            } : null}
            status={getStatus(car)}
            isUpcomingCar={isUpcomingCar}
            timerRemainingSeconds={getRemainingSeconds(car)}
            showCancelAuction={showCancelAuction}
            onCancelAuction={onCancelAuction}
            showCurrentHighestOffer={showCurrentHighestOffer}
            showCarLabelStatus={showCarLabelStatus}
            showMenuButton={showMenuButton}
            showSimilarCarsButton={showSimilarCarsButton}
            onClickShowSimilarCars={onClickShowSimilarCars}
            cardWidth={cardWidth}
            cardMinWidth={cardMinWidth}
            showAgentPendingApprovalStatus={showAgentPendingApprovalStatus}
            tab={tab}
            onProcessPayment={onProcessPayment}
            cardType={cardType}
            {...otherProps}
          />
        ))}
      </Grid>
    </Box>
  );
};

export default CarsList;
